import { render, staticRenderFns } from "./MenuManagementDialog.vue?vue&type=template&id=24bf0956&scoped=true&"
import script from "./MenuManagementDialog.vue?vue&type=script&lang=js&"
export * from "./MenuManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./MenuManagementDialog.vue?vue&type=style&index=0&id=24bf0956&scoped=true&lang=scss&"
import style1 from "./MenuManagementDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf0956",
  null
  
)

export default component.exports